import { Suspense } from 'react';
import { Loading } from './loading';
import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';
import {
  FETCH_PROGRAMMES,
  FetchProgrammesQuery,
  FetchProgrammesQueryVariables,
  HomePage,
  Programme,
} from '@edwin-group/cj-graphql';
import { Link } from 'react-router-dom';
import { Card } from '@/pages/mission/listing/components/programmes/components/card';
import { getSchoolContext } from '@/hooks/useAuthentication';
import { useSuspenseQuery } from '@apollo/client';
import FieldError from '@/components/FieldError';

export const ProgrammesComponent = ({ page }: { page: HomePage }) => {
  const viewAllUrl = '/programmes';
  const { title, viewAll: viewAllText } = page?.programmeSection || {};

  const { data: programmesResult, error: programmesError } = useSuspenseQuery<
    FetchProgrammesQuery,
    FetchProgrammesQueryVariables
  >(FETCH_PROGRAMMES, {
    fetchPolicy: 'cache-and-network',
    variables: {
      sort: 'missions.keyStage.order:asc',
      schoolId: getSchoolContext()?.documentId,
    },
    errorPolicy: 'all',
  });

  const viewAll = (programmesResult?.programmes?.length || 0) > 2;

  if (programmesError) {
    return <FieldError message={programmesError.message} />;
  }

  if (programmesResult?.programmes?.length === 0) {
    return <div>No programmes found</div>;
  }

  return (
    <AnimatedFadeInComponent fromBottom>
      <div>
        <div className="flex items-center justify-between">
          <h3 className="mb-sh-15 font-cadiz text-sh-28-32 font-bold">{title}</h3>
          {viewAll ? (
            <Link className="text-sh-xxxs font-bold text-primary-600" to={viewAllUrl}>
              {viewAllText}
            </Link>
          ) : null}
        </div>
        <div className="grid grid-cols-1 gap-sh-15 md:grid-cols-2 lg:grid-cols-3">
          {programmesResult?.programmes?.map((programme) => {
            return (
              <Card programme={programme as Programme} key={programme?.documentId} seeMissionButtonText={'Start'} />
            );
          })}
        </div>
      </div>
      {/* {showDivider ? <Divider /> : null} */}
    </AnimatedFadeInComponent>
  );
};

export function Programmes({ page }: { page: HomePage }) {
  return (
    <Suspense fallback={<Loading />}>
      <ProgrammesComponent page={page} />
    </Suspense>
  );
}
